import React, { useEffect, useState } from 'react';
import MenuAssignments from './sgc/MenuAssignments';
import Home from './sgc/Home';
import Loading from '../Loading';
import Planning from './sgc/Planning';

const components = {
    Loading,
    Home,
    Planning,
};

const Assignments = (props) => {
    const { data, ModuleRP, locale, theme } = props;

    const [activePage, setActivePage] = useState('Home');
    const [buildings, setBuildings] = useState([]);
    const [assignment, setAssignment] = useState(null);
    const Component = components[activePage];

    const changeBatiment = (id) => {
        setAssignment(id);
        setActivePage('Home');
    };

    useEffect(() => {
        if (data.assignments) {
            setBuildings(data.assignments.filter((a) => a.staff.includes(ModuleRP.userId)));
            if (!assignment && buildings && buildings.length > 0) {
                changeBatiment(buildings[0].id);
            }
        }
    }, [activePage, data, assignment]);

    return (
        <div className={`container-fluid p-0 bg-${theme === 'DARK' ? 'dark' : 'light'} configuration d-flex`}>
            {
                !data.type && data.type !== 'game' && buildings.length > 0 ?
                    <>
                        <MenuAssignments
                            locale={locale}
                            setActivePage={setActivePage}
                            theme={theme}
                            ModuleRP={ModuleRP}
                            activePage={activePage}
                            data={{ assignments: buildings }}
                            assignment={assignment}
                            setAssignment={changeBatiment}
                        />
                        <Component
                            data={data}
                            locale={locale}
                            theme={theme}
                            ModuleRP={ModuleRP}
                            assignment={assignment}
                        />
                    </> : <Loading theme={theme} />
            }
        </div>
    );
};

export default Assignments;
